<template>
    <home-content :page-name="'newsworthy'"></home-content>
</template>

<script>
    import HomeContent from "./HomeContent";
    export default {
        name: 'Newsworthy',
        components: {HomeContent},
        beforeRouteEnter(to, from, next) {
            Store.page.home.clear();
            if (Store.page.home.page === 0) {
                if (typeof app != "undefined") {
                    app.$Progress.start();
                }
                Store.settings.feed.submissionsFilter = 'subscribed'

                Store.page.home.getSubmissions(to.query.sort, to.name).then(() => {
                    next(vm => vm.$Progress.finish());
                });
            } else {
                next();
            }
        },

        beforeRouteUpdate(to, from, next) {
            if (to.hash !== from.hash) return;

            Store.page.home.clear();

            this.$Progress.start();

            Store.page.home.getSubmissions(to.query.sort).then(() => {
                this.$Progress.finish();
                next();
            });
        },
    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Newsworthy.vue